class Map {

    /**
     * @since 4.0.0
     * @param object element is the map container
     * @method constructor
     */
    constructor(element) {
        // Set our element
        this.element = element;

        // If we are missing required classes, bail
        if ('undefined' === typeof google) return;

        // Run initialization
        this.init()
    }

    /**
     * Initialize a new map.
     *
     * @method init
     * @since 4.0.0
     * @returns object The initialized map
     */
    init() {

        // Declare and initialize
        var self    = this;
        var markers = this.element.find('.marker');
        var args    = {
            zoom:      this.element.data('zoom') || 16,
            center:    new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            //gestureHandling: 'greedy'
        };

        // Create the new map
        var map = new google.maps.Map(this.element[0], args);

        // Initialize the set of markers
        map.markers = [];

        // Iterate through our markers
        markers.each(function () {

            // Add this marker
            self.addMarker($(this), map);

        });

        // Center the map around the markers
        this.center(map, map.getZoom());

        // Give up the reference to the map that was created
        return map;

    }

    /**
     * Add a marker to a given map.
     *
     * @method addMarker
     * @since 4.0.0
     * @param object ele is the element containing marker values
     * @param object map is the map on which to mark
     * @return void
     */
    addMarker(ele, map) {

        // Declare and initialize
        var override = ele.hasClass('address-override');
        var address  = ele.data('address');
        var lat      = override ? null : ele.data('lat');
        var lng      = override ? null : ele.data('lng');

        // Determine position based on available values
        if (override) {

            // Extrapolate the position
            this.geocode(ele, address, map);

        } else {

            // Create a new marker
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, lng),
                map:      map,
                icon:     ele.data('icon') || '',
                title:    address
            });

            // Add the newly-created marker to the set of markers
            map.markers.push(marker);

            // Handle any info windows
            this.infoWindow(ele, marker, map);
        }

    }


    /**
     * Center the map on the marker(s) provided.
     *
     * @since 4.0.0
     * @method center
     * @param object map is the map that will be adjusted
     * @param int zoom is the zoom level for the map provided
     * @return void
     */
    center(map, zoom) {

        // Declare and initialize
        var bounds = new google.maps.LatLngBounds();

        // Loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {

            // Declare and initialize
            var lat = marker.position.lat();
            var lng = marker.position.lng()

            // Extend the map boundaries to include new position
            bounds.extend(new google.maps.LatLng(lat, lng));

        });

        // We respect zoom level if there is only one marker
        if (1 == map.markers.length) {

            // Focus on the center of the map
            map.setCenter(bounds.getCenter());

            // Set the zoom level
            map.setZoom(zoom);

        } else {

            // Fit all of our markers in the view
            map.fitBounds(bounds);

        }

    }

    /**
     * Extrapolate the latitude and longitude from an address string.
     *
     * @since 4.0.0
     * @method geocode
     * @param object ele is the marker source element
     * @param string address is the address to geocode
     * @param object map is the map that will be adjusted
     * @param object The position object representing coordinates
     * @return void
     */
    geocode(ele, address, map) {
        // Declare and initialize
        var geocoder = new google.maps.Geocoder();
        var zoom     = map.getZoom();

        // Run the geocoding
        geocoder.geocode({'address': address},
            (results, status) => {

                // If it failed, return nothing
                if (status !== 'OK') return;

                // Create a new marker
                var marker = new google.maps.Marker({
                    position: results[0].geometry.location,
                    map:      map,
                    icon:     ele.data('icon') || '',
                    title:    results[0].formatted_address
                });

                // Add to the list of markers
                map.markers.push(marker);

                // Prevent zoom from changing
                if (1 == map.markers.length)
                    map.setZoom(zoom);

                // Handle any info windows
                this.infoWindow(ele, marker, map);

                // Recenter the map
                this.center(map, map.getZoom());

            }
        );
    }

    /**
     * Manage info windows defined by a marker.
     *
     * @since 4.0.0
     * @method infoWindow
     * @param object ele is the marker source element
     * @param object marker is the trigger marker to show the info window
     * @param object map is the host map
     * @return void
     */
    infoWindow(ele, marker, map) {
        // Declare and initialize
        var uri        = 'https://www.google.com/maps/place/';
        var lat        = marker.position.lat();
        var lng        = marker.position.lng();
        var title      = marker.title || '';
        var slug       = title.replace(/[\W_]+/g, '+');
        var link       = uri + slug;
        var infoWindow = new google.maps.InfoWindow({
            content: '<div>' +
                         '<p>' + title + '</p>' +
                         '<a href="' + link + '" target="_blank">' +
                         'View on Google Maps ' +
                         '&rarr;' +
                         '</a> ' +
                         '</div>'
        });

        // Listen for when the marker is clicked
        google.maps.event.addListener(marker, 'click', () => {

            // Show the info window
            infoWindow.open(map, marker);

        });
    }
}

export default Map;